import React from "react";
import * as S from "../../style/StyleComponentSection";

import { useNavigate } from "react-router-dom";

const ReservationSuccess: React.FC = () => {
    const navigate = useNavigate();

    return (
        <S.SectionContainer>
            <S.SectionWidth $width={1080}>
                <S.SectionTitleBox>
                    <h1>A.Black 서비스 예약</h1>
                    <h3>수입조명 시공 전문 인스톨러가 당신의 공간에 빛을 선물합니다.</h3>
                </S.SectionTitleBox>

                <br />
                <S.SectionBorderContainer className="flex justify-center" style={{width : "550px", height : "200px"}}>
                    <div className="mt-[60px] text-center">
                        <h1 className="font-semibold text-[18px]">예약이 완료됐습니다.</h1>
                        <p className="font-light text-[14px] mt-4">라이팅 인스톨러의 하이엔드 시공 서비스를</p>
                        <p className="font-light text-[14px]">선택해주셔서 감사합니다.</p>
                    </div>
                </S.SectionBorderContainer>

                <br />
                <S.SectionContent style={{width : "410px"}}>
                        <div className="section-flex-box w-[100%] justify-center">
                            <S.EmptyRoundedButton style={{backgroundColor : "#fff", color : "#111827"}} $width={195} $btnSelect onClick={() => navigate('/reservation_detail')}>
                                예약 내역
                            </S.EmptyRoundedButton>
                        </div>
                        <div className="section-flex-box w-[100%] justify-center">
                            <S.EmptyRoundedButton style={{backgroundColor : "#111827", color : "#FFF"}} $width={195} $btnSelect onClick={() => navigate('/main')}>
                                메인 페이지
                            </S.EmptyRoundedButton>
                        </div>
                    </S.SectionContent>

            </S.SectionWidth>
        </S.SectionContainer>
    )
};

export default ReservationSuccess;